import { Outlet } from 'react-router';

import { Header } from '@src/components/layouts/Header/Header';

export const AuthLayout = () => {
  return (
    <div className="flex min-h-screen flex-col items-center px-20 max-sm:px-0">
      <Header containerClassName="mb-0" contentClassName="pb-0" />
      <div className="w-full max-w-[24rem] max-sm:px-4 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};
